// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --brand:       #1565C0;
  --brand-soft:  #E3F2FD;
  --orange:      #F4511E;
  --orange-deep: #D84315;
  --orange-glow: rgba(244,81,30,0.18);
  --surface:     #ffffff;
  --bg:          #EEF4FB;
  --border:      #e8edf5;
  --text-1:      #1a1a1a;
  --text-2:      #555;
  --text-3:      #888;
  --danger:      #EF4444;
  --danger-soft: #FEF2F2;
  --success:     #16A34A;
  --font:        'Plus Jakarta Sans', sans-serif;
  --ease:        cubic-bezier(0.16, 1, 0.3, 1);
  --r:           10px;
}

* { box-sizing: border-box; }

/* ── Page ── */
.wl-page {
  font-family: var(--font);
  max-width: 1200px;
  margin: 70px auto 60px;
  background: var(--bg);
  padding: 28px 20px 30px;
}

/* ── Slim white topbar ── */
.wl-topbar {
  background: var(--surface);
  padding: 14px 22px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: var(--radius-md);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  position: relative;
  overflow: hidden;
}

.wl-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  background: transparent;
  border: 1px solid var(--border);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 12px;
  font-weight: 600;
  color: var(--text-2);
  cursor: pointer;
  transition: all 0.16s;
  flex-shrink: 0;
}
.wl-back-btn:hover { border-color: var(--brand); color: var(--brand); background: var(--brand-soft); }
.wl-back-btn svg { font-size: 10px; }

/* Plain "Wishlist" text — no icon, no badge styling */
.wl-topbar-title {
  font-size: 15px;
  font-weight: 700;
  color: var(--text-1);
}

.wl-topbar-count {
  font-size: 11px;
  font-weight: 500;
  color: var(--text-3);
}

/* ── Content — centered, capped at 5-card width ── */
.wl-content {
  flex: 2 1;
  background: var(--surface);
  border-radius: var(--radius-lg);
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
  overflow: hidden;
  padding: 70px;
}

/* ── Grid: exactly 5 columns, centered ── */
.wl-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  justify-items: center;
}

/* ── Card ── */
.wl-card {
  background: var(--surface);
  border-radius: var(--r);
  border: 1px solid var(--border);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 100%;
  transition: box-shadow 0.2s var(--ease), transform 0.2s var(--ease);
  animation: wlIn 0.3s var(--ease) both;
}

@keyframes wlIn {
  from { opacity: 0; transform: translateY(10px); }
  to   { opacity: 1; transform: translateY(0); }
}
.wl-card:nth-child(1)  { animation-delay: 0.03s; }
.wl-card:nth-child(2)  { animation-delay: 0.06s; }
.wl-card:nth-child(3)  { animation-delay: 0.09s; }
.wl-card:nth-child(4)  { animation-delay: 0.12s; }
.wl-card:nth-child(5)  { animation-delay: 0.15s; }
.wl-card:nth-child(6)  { animation-delay: 0.18s; }
.wl-card:nth-child(7)  { animation-delay: 0.21s; }
.wl-card:nth-child(8)  { animation-delay: 0.24s; }

.wl-card:hover {
  box-shadow: 0 4px 18px rgba(0,0,0,0.11);
  transform: translateY(-3px);
}

/* ── Image ── */
.wl-card-img-wrap {
  width: 100%;
  height: 170px;
  background: #f7f8fa;
  overflow: hidden;
  /* NO relative positioning — no FAB overlay */
}

.wl-card-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
  transition: transform 0.3s var(--ease);
}
.wl-card:hover .wl-card-img { transform: scale(1.04); }

/* Discount badge — keep this, it's useful info */
.wl-card-discount-badge {
  display: inline-block;
  background: linear-gradient(135deg, var(--orange), var(--orange-deep));
  color: #fff;
  font-size: 9.5px;
  font-weight: 800;
  padding: 2px 7px;
  border-radius: 100px;
  letter-spacing: 0.3px;
  margin-bottom: 2px;
  width: fit-content;
}

/* ── Card body ── */
.wl-card-body {
  padding: 11px 13px 13px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
  gap: 2px;
}

.wl-card-name {
  font-size: 13px;
  font-weight: 700;
  color: var(--text-1);
  margin: 0 0 1px;
  line-height: 1.35;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.wl-card-subtitle {
  font-size: 10.5px;
  color: var(--text-3);
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.wl-card-category {
  font-size: 11px;
  font-weight: 600;
  color: var(--text-2);
  margin: 2px 0 0;
}

.wl-card-location {
  display: flex;
  align-items: center;
  gap: 3px;
  font-size: 10.5px;
  color: var(--text-3);
  margin: 1px 0 0;
}

.wl-card-divider {
  height: 1px;
  background: var(--border);
  margin: 7px 0 5px;
}

.wl-card-price {
  font-size: 16px;
  font-weight: 800;
  color: var(--text-1);
  letter-spacing: -0.3px;
  margin: 0;
}

.wl-card-discount-text {
  font-size: 11.5px;
  font-weight: 600;
  color: var(--success);
  margin: 1px 0 0;
}

.wl-card-mrp {
  font-size: 11px;
  color: var(--text-3);
  text-decoration: line-through;
  margin: 0;
}

/* ── Add to Cart ── */
.wl-card-cart-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  padding: 9px 0;
  margin-top: 10px;
  background: var(--orange);
  color: #fff;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s var(--ease);
}
.wl-card-cart-btn:hover { background: var(--orange-deep); box-shadow: 0 3px 12px var(--orange-glow); }
.wl-card-cart-btn:active { transform: scale(0.98); }
.wl-card-cart-btn svg { font-size: 11px; }

/* ── Remove button ── */
.wl-card-remove-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  padding: 6px 0;
  margin-top: 5px;
  background: transparent;
  color: var(--text-3);
  border: 1px solid var(--border);
  border-radius: 100px;
  font-family: var(--font);
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.16s;
}
.wl-card-remove-btn:hover { background: var(--danger-soft); border-color: #FECACA; color: var(--danger); }
.wl-card-remove-btn svg { font-size: 9.5px; }

/* ── Loading ── */
.wl-spinner-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  min-height: 280px;
}
.wl-spinner {
  width: 36px; height: 36px;
  border: 3px solid var(--brand-soft);
  border-top-color: var(--brand);
  border-radius: 50%;
  animation: wlSpin 0.7s linear infinite;
}
@keyframes wlSpin { to { transform: rotate(360deg); } }
.wl-spinner-text { font-size: 13px; font-weight: 600; color: var(--brand); margin: 0; }

/* ── Empty ── */
.wl-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 60px 24px;
  background: var(--surface);
  border-radius: var(--r);
  border: 1px solid var(--border);
  gap: 8px;
}
.wl-empty-icon { font-size: 44px; opacity: 0.4; }
.wl-empty h3 { font-size: 18px; font-weight: 800; color: var(--text-1); margin: 0; }
.wl-empty p  { font-size: 13px; color: var(--text-3); margin: 0; max-width: 240px; line-height: 1.6; }
.wl-empty-cta {
  margin-top: 6px;
  padding: 9px 24px;
  background: var(--orange);
  color: #fff;
  border: none;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.18s;
}
.wl-empty-cta:hover { background: var(--orange-deep); transform: translateY(-1px); }

/* ── Error ── */
.wl-error {
  color: var(--danger);
  background: var(--danger-soft);
  border: 1px solid #FECACA;
  border-left: 4px solid var(--danger);
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  font-family: var(--font);
}

/* ── Modal ── */
.wl-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.42);
  backdrop-filter: blur(5px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.wl-modal {
  background: var(--surface);
  border-radius: 14px;
  box-shadow: 0 20px 50px rgba(0,0,0,0.16);
  min-width: 280px;
  max-width: 88vw;
  text-align: center;
  overflow: hidden;
  animation: wlModalIn 0.22s var(--ease);
}
@keyframes wlModalIn {
  from { opacity: 0; transform: scale(0.94) translateY(14px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}
.wl-modal::before { content: ''; display: block; height: 3px; background: linear-gradient(90deg, var(--danger), #FF8A80); }
.wl-modal-icon { font-size: 32px; padding-top: 18px; line-height: 1; }
.wl-modal h3 { font-family: var(--font); font-size: 15px; font-weight: 800; color: var(--text-1); padding: 8px 22px 3px; margin: 0; }
.wl-modal p  { font-family: var(--font); font-size: 12.5px; color: var(--text-3); padding: 0 22px 14px; margin: 0; line-height: 1.5; }
.wl-modal-btns { display: flex; gap: 8px; justify-content: center; padding: 2px 18px 18px; }
.wl-modal-confirm {
  padding: 8px 20px;
  background: var(--danger); color: #fff; border: none; border-radius: 100px;
  font-family: var(--font); font-size: 12.5px; font-weight: 700; cursor: pointer; transition: all 0.16s;
}
.wl-modal-confirm:hover { background: #DC2626; }
.wl-modal-cancel {
  padding: 8px 20px;
  background: #f4f4f4; color: var(--text-2); border: 1px solid var(--border); border-radius: 100px;
  font-family: var(--font); font-size: 12.5px; font-weight: 600; cursor: pointer; transition: all 0.16s;
}
.wl-modal-cancel:hover { background: #eee; }

/* ── Toast ── */
.wl-toast {
  position: fixed;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 9000;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 100px;
  font-family: var(--font);
  font-size: 12.5px;
  font-weight: 600;
  box-shadow: 0 5px 20px rgba(0,0,0,0.18);
  white-space: nowrap;
  animation: wlToastIn 0.22s var(--ease);
}
@keyframes wlToastIn {
  from { opacity: 0; transform: translateX(-50%) translateY(10px); }
  to   { opacity: 1; transform: translateX(-50%) translateY(0); }
}
.wl-toast--success { background: #111; color: #fff; }
.wl-toast--error   { background: var(--danger); color: #fff; }
.wl-toast-cart-btn {
  padding: 4px 12px;
  background: var(--orange); color: #fff; border: none; border-radius: 100px;
  font-family: var(--font); font-size: 11.5px; font-weight: 700; cursor: pointer;
}
.wl-toast-cart-btn:hover { background: var(--orange-deep); }

/* ======================================
   RESPONSIVE
====================================== */
/* 4 cols on medium desktop */
@media (max-width: 1100px) {
  .wl-grid { grid-template-columns: repeat(4, 1fr); }
}

/* 3 cols on tablet */
@media (max-width: 820px) {
  .wl-grid { grid-template-columns: repeat(3, 1fr); gap: 12px; }
  .wl-content { padding: 16px 14px 50px; }
}

/* 2 cols on mobile — SMALL images */
@media (max-width: 600px) {
  .wl-page {width: 100%;  border-radius: 0; padding: 16px 12px 30px;}
  .wl-grid { grid-template-columns: repeat(2, 1fr); gap: 9px; }
  .wl-content { padding: 12px 10px 50px; gap: 20px;}

  /* KEY FIX: much shorter image on mobile */
  .wl-card-img-wrap { height: 110px; }

  .wl-card-body  { padding: 8px 10px 10px; gap: 1px; }
  .wl-card-name  { font-size: 11.5px; }
  .wl-card-price { font-size: 13.5px; }
  .wl-card-discount-text { font-size: 10.5px; }
  .wl-card-mrp   { font-size: 10px; }
  .wl-card-cart-btn   { font-size: 11px; padding: 7px 0; margin-top: 7px; }
  .wl-card-remove-btn { font-size: 10px; padding: 5px 0; }
  .wl-card-divider    { margin: 5px 0 4px; }

  .wl-topbar       { padding: 9px 12px; gap: 10px; }
  .wl-topbar-title { font-size: 13.5px; }
  .wl-back-btn     { padding: 5px 11px; font-size: 11.5px; }

  .wl-toast {
    border-radius: 10px; white-space: normal; flex-direction: column;
    gap: 5px; max-width: 86vw; text-align: center; bottom: 12px;
  }
}

/* Very small phones */
@media (max-width: 380px) {
  .wl-card-img-wrap { height: 95px; }
  .wl-card-name     { font-size: 11px; }
  .wl-card-price    { font-size: 13px; }
}`, "",{"version":3,"sources":["webpack://./src/components/Wishlist.css"],"names":[],"mappings":"AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mCAAmC;EACnC,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,8CAA8C;EAC9C,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA,IAAI,sBAAsB,EAAE;;AAE5B,eAAe;AACf;EACE,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,4BAA4B;AAC5B;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,uBAAuB;EACvB,+BAA+B;EAC/B,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;AACA,qBAAqB,0BAA0B,EAAE,mBAAmB,EAAE,6BAA6B,EAAE;AACrG,mBAAmB,eAAe,EAAE;;AAEpC,sDAAsD;AACtD;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,qDAAqD;AACrD;EACE,SAAO;EACP,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;AACf;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mEAAmE;EACnE,qCAAqC;AACvC;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,OAAO,UAAU,EAAE,wBAAwB,EAAE;AAC/C;AACA,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;AACjD,yBAAyB,sBAAsB,EAAE;;AAEjD;EACE,uCAAuC;EACvC,2BAA2B;AAC7B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;AACA,8BAA8B,sBAAsB,EAAE;;AAEtD,iDAAiD;AACjD;EACE,qBAAqB;EACrB,sEAAsE;EACtE,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAO;EACP,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,oBAAoB;EACpB,6BAA6B;EAC7B,SAAS;AACX;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iCAAiC;AACnC;AACA,0BAA0B,8BAA8B,EAAE,yCAAyC,EAAE;AACrG,2BAA2B,sBAAsB,EAAE;AACnD,wBAAwB,eAAe,EAAE;;AAEzC,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,cAAc;EACd,eAAe;EACf,uBAAuB;EACvB,oBAAoB;EACpB,+BAA+B;EAC/B,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,4BAA4B,8BAA8B,EAAE,qBAAqB,EAAE,oBAAoB,EAAE;AACzG,0BAA0B,gBAAgB,EAAE;;AAE5C,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,WAAW,EAAE,YAAY;EACzB,mCAAmC;EACnC,8BAA8B;EAC9B,kBAAkB;EAClB,sCAAsC;AACxC;AACA,oBAAoB,KAAK,yBAAyB,EAAE,EAAE;AACtD,mBAAmB,eAAe,EAAE,gBAAgB,EAAE,mBAAmB,EAAE,SAAS,EAAE;;AAEtF,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,QAAQ;AACV;AACA,iBAAiB,eAAe,EAAE,YAAY,EAAE;AAChD,eAAe,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,SAAS,EAAE;AACnF,eAAe,eAAe,EAAE,oBAAoB,EAAE,SAAS,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AACrG;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,wBAAwB;EACxB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;AACA,sBAAsB,8BAA8B,EAAE,2BAA2B,EAAE;;AAEnF,gBAAgB;AAChB;EACE,oBAAoB;EACpB,8BAA8B;EAC9B,yBAAyB;EACzB,oCAAoC;EACpC,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA,gBAAgB;AAChB;EACE,eAAe;EACf,QAAQ;EACR,4BAA4B;EAC5B,0BAA0B;EAC1B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,wCAAwC;EACxC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;AACA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,OAAO,UAAU,EAAE,iCAAiC,EAAE;AACxD;AACA,oBAAoB,WAAW,EAAE,cAAc,EAAE,WAAW,EAAE,0DAA0D,EAAE;AAC1H,iBAAiB,eAAe,EAAE,iBAAiB,EAAE,cAAc,EAAE;AACrE,eAAe,wBAAwB,EAAE,eAAe,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,qBAAqB,EAAE,SAAS,EAAE;AACpI,eAAe,wBAAwB,EAAE,iBAAiB,EAAE,oBAAoB,EAAE,oBAAoB,EAAE,SAAS,EAAE,gBAAgB,EAAE;AACrI,iBAAiB,aAAa,EAAE,QAAQ,EAAE,uBAAuB,EAAE,sBAAsB,EAAE;AAC3F;EACE,iBAAiB;EACjB,yBAAyB,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB;EAC1E,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB;AACvG;AACA,0BAA0B,mBAAmB,EAAE;AAC/C;EACE,iBAAiB;EACjB,mBAAmB,EAAE,oBAAoB,EAAE,+BAA+B,EAAE,oBAAoB;EAChG,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB;AACvG;AACA,yBAAyB,gBAAgB,EAAE;;AAE3C,gBAAgB;AAChB;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;EACnB,sCAAsC;AACxC;AACA;EACE,OAAO,UAAU,EAAE,4CAA4C,EAAE;EACjE,OAAO,UAAU,EAAE,yCAAyC,EAAE;AAChE;AACA,qBAAqB,gBAAgB,EAAE,WAAW,EAAE;AACpD,qBAAqB,yBAAyB,EAAE,WAAW,EAAE;AAC7D;EACE,iBAAiB;EACjB,yBAAyB,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB;EAC1E,wBAAwB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,eAAe;AAChF;AACA,2BAA2B,8BAA8B,EAAE;;AAE3D;;wCAEwC;AACxC,6BAA6B;AAC7B;EACE,WAAW,qCAAqC,EAAE;AACpD;;AAEA,qBAAqB;AACrB;EACE,WAAW,qCAAqC,EAAE,SAAS,EAAE;EAC7D,cAAc,uBAAuB,EAAE;AACzC;;AAEA,oCAAoC;AACpC;EACE,UAAU,WAAW,GAAG,gBAAgB,EAAE,uBAAuB,CAAC;EAClE,WAAW,qCAAqC,EAAE,QAAQ,EAAE;EAC5D,cAAc,uBAAuB,EAAE,SAAS,CAAC;;EAEjD,0CAA0C;EAC1C,oBAAoB,aAAa,EAAE;;EAEnC,iBAAiB,sBAAsB,EAAE,QAAQ,EAAE;EACnD,iBAAiB,iBAAiB,EAAE;EACpC,iBAAiB,iBAAiB,EAAE;EACpC,yBAAyB,iBAAiB,EAAE;EAC5C,iBAAiB,eAAe,EAAE;EAClC,sBAAsB,eAAe,EAAE,cAAc,EAAE,eAAe,EAAE;EACxE,sBAAsB,eAAe,EAAE,cAAc,EAAE;EACvD,sBAAsB,iBAAiB,EAAE;;EAEzC,mBAAmB,iBAAiB,EAAE,SAAS,EAAE;EACjD,mBAAmB,iBAAiB,EAAE;EACtC,mBAAmB,iBAAiB,EAAE,iBAAiB,EAAE;;EAEzD;IACE,mBAAmB,EAAE,mBAAmB,EAAE,sBAAsB;IAChE,QAAQ,EAAE,eAAe,EAAE,kBAAkB,EAAE,YAAY;EAC7D;AACF;;AAEA,sBAAsB;AACtB;EACE,oBAAoB,YAAY,EAAE;EAClC,oBAAoB,eAAe,EAAE;EACrC,oBAAoB,eAAe,EAAE;AACvC","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');\n\n:root {\n  --brand:       #1565C0;\n  --brand-soft:  #E3F2FD;\n  --orange:      #F4511E;\n  --orange-deep: #D84315;\n  --orange-glow: rgba(244,81,30,0.18);\n  --surface:     #ffffff;\n  --bg:          #EEF4FB;\n  --border:      #e8edf5;\n  --text-1:      #1a1a1a;\n  --text-2:      #555;\n  --text-3:      #888;\n  --danger:      #EF4444;\n  --danger-soft: #FEF2F2;\n  --success:     #16A34A;\n  --font:        'Plus Jakarta Sans', sans-serif;\n  --ease:        cubic-bezier(0.16, 1, 0.3, 1);\n  --r:           10px;\n}\n\n* { box-sizing: border-box; }\n\n/* ── Page ── */\n.wl-page {\n  font-family: var(--font);\n  max-width: 1200px;\n  margin: 70px auto 60px;\n  background: var(--bg);\n  padding: 28px 20px 30px;\n}\n\n/* ── Slim white topbar ── */\n.wl-topbar {\n  background: var(--surface);\n  padding: 14px 22px;\n  margin-bottom: 16px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n  overflow: hidden;\n}\n\n.wl-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 14px;\n  background: transparent;\n  border: 1px solid var(--border);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-2);\n  cursor: pointer;\n  transition: all 0.16s;\n  flex-shrink: 0;\n}\n.wl-back-btn:hover { border-color: var(--brand); color: var(--brand); background: var(--brand-soft); }\n.wl-back-btn svg { font-size: 10px; }\n\n/* Plain \"Wishlist\" text — no icon, no badge styling */\n.wl-topbar-title {\n  font-size: 15px;\n  font-weight: 700;\n  color: var(--text-1);\n}\n\n.wl-topbar-count {\n  font-size: 11px;\n  font-weight: 500;\n  color: var(--text-3);\n}\n\n/* ── Content — centered, capped at 5-card width ── */\n.wl-content {\n  flex: 2;\n  background: var(--surface);\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n  overflow: hidden;\n  padding: 70px;\n}\n\n/* ── Grid: exactly 5 columns, centered ── */\n.wl-grid {\n  display: grid;\n  grid-template-columns: repeat(5, 1fr);\n  gap: 14px;\n  justify-items: center;\n}\n\n/* ── Card ── */\n.wl-card {\n  background: var(--surface);\n  border-radius: var(--r);\n  border: 1px solid var(--border);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  transition: box-shadow 0.2s var(--ease), transform 0.2s var(--ease);\n  animation: wlIn 0.3s var(--ease) both;\n}\n\n@keyframes wlIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to   { opacity: 1; transform: translateY(0); }\n}\n.wl-card:nth-child(1)  { animation-delay: 0.03s; }\n.wl-card:nth-child(2)  { animation-delay: 0.06s; }\n.wl-card:nth-child(3)  { animation-delay: 0.09s; }\n.wl-card:nth-child(4)  { animation-delay: 0.12s; }\n.wl-card:nth-child(5)  { animation-delay: 0.15s; }\n.wl-card:nth-child(6)  { animation-delay: 0.18s; }\n.wl-card:nth-child(7)  { animation-delay: 0.21s; }\n.wl-card:nth-child(8)  { animation-delay: 0.24s; }\n\n.wl-card:hover {\n  box-shadow: 0 4px 18px rgba(0,0,0,0.11);\n  transform: translateY(-3px);\n}\n\n/* ── Image ── */\n.wl-card-img-wrap {\n  width: 100%;\n  height: 170px;\n  background: #f7f8fa;\n  overflow: hidden;\n  /* NO relative positioning — no FAB overlay */\n}\n\n.wl-card-img {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n  transition: transform 0.3s var(--ease);\n}\n.wl-card:hover .wl-card-img { transform: scale(1.04); }\n\n/* Discount badge — keep this, it's useful info */\n.wl-card-discount-badge {\n  display: inline-block;\n  background: linear-gradient(135deg, var(--orange), var(--orange-deep));\n  color: #fff;\n  font-size: 9.5px;\n  font-weight: 800;\n  padding: 2px 7px;\n  border-radius: 100px;\n  letter-spacing: 0.3px;\n  margin-bottom: 2px;\n  width: fit-content;\n}\n\n/* ── Card body ── */\n.wl-card-body {\n  padding: 11px 13px 13px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  gap: 2px;\n}\n\n.wl-card-name {\n  font-size: 13px;\n  font-weight: 700;\n  color: var(--text-1);\n  margin: 0 0 1px;\n  line-height: 1.35;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.wl-card-subtitle {\n  font-size: 10.5px;\n  color: var(--text-3);\n  margin: 0;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.wl-card-category {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--text-2);\n  margin: 2px 0 0;\n}\n\n.wl-card-location {\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  font-size: 10.5px;\n  color: var(--text-3);\n  margin: 1px 0 0;\n}\n\n.wl-card-divider {\n  height: 1px;\n  background: var(--border);\n  margin: 7px 0 5px;\n}\n\n.wl-card-price {\n  font-size: 16px;\n  font-weight: 800;\n  color: var(--text-1);\n  letter-spacing: -0.3px;\n  margin: 0;\n}\n\n.wl-card-discount-text {\n  font-size: 11.5px;\n  font-weight: 600;\n  color: var(--success);\n  margin: 1px 0 0;\n}\n\n.wl-card-mrp {\n  font-size: 11px;\n  color: var(--text-3);\n  text-decoration: line-through;\n  margin: 0;\n}\n\n/* ── Add to Cart ── */\n.wl-card-cart-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  padding: 9px 0;\n  margin-top: 10px;\n  background: var(--orange);\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.18s var(--ease);\n}\n.wl-card-cart-btn:hover { background: var(--orange-deep); box-shadow: 0 3px 12px var(--orange-glow); }\n.wl-card-cart-btn:active { transform: scale(0.98); }\n.wl-card-cart-btn svg { font-size: 11px; }\n\n/* ── Remove button ── */\n.wl-card-remove-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  width: 100%;\n  padding: 6px 0;\n  margin-top: 5px;\n  background: transparent;\n  color: var(--text-3);\n  border: 1px solid var(--border);\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.16s;\n}\n.wl-card-remove-btn:hover { background: var(--danger-soft); border-color: #FECACA; color: var(--danger); }\n.wl-card-remove-btn svg { font-size: 9.5px; }\n\n/* ── Loading ── */\n.wl-spinner-wrap {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 14px;\n  min-height: 280px;\n}\n.wl-spinner {\n  width: 36px; height: 36px;\n  border: 3px solid var(--brand-soft);\n  border-top-color: var(--brand);\n  border-radius: 50%;\n  animation: wlSpin 0.7s linear infinite;\n}\n@keyframes wlSpin { to { transform: rotate(360deg); } }\n.wl-spinner-text { font-size: 13px; font-weight: 600; color: var(--brand); margin: 0; }\n\n/* ── Empty ── */\n.wl-empty {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  padding: 60px 24px;\n  background: var(--surface);\n  border-radius: var(--r);\n  border: 1px solid var(--border);\n  gap: 8px;\n}\n.wl-empty-icon { font-size: 44px; opacity: 0.4; }\n.wl-empty h3 { font-size: 18px; font-weight: 800; color: var(--text-1); margin: 0; }\n.wl-empty p  { font-size: 13px; color: var(--text-3); margin: 0; max-width: 240px; line-height: 1.6; }\n.wl-empty-cta {\n  margin-top: 6px;\n  padding: 9px 24px;\n  background: var(--orange);\n  color: #fff;\n  border: none;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: all 0.18s;\n}\n.wl-empty-cta:hover { background: var(--orange-deep); transform: translateY(-1px); }\n\n/* ── Error ── */\n.wl-error {\n  color: var(--danger);\n  background: var(--danger-soft);\n  border: 1px solid #FECACA;\n  border-left: 4px solid var(--danger);\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 500;\n  font-family: var(--font);\n}\n\n/* ── Modal ── */\n.wl-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0,0,0,0.42);\n  backdrop-filter: blur(5px);\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.wl-modal {\n  background: var(--surface);\n  border-radius: 14px;\n  box-shadow: 0 20px 50px rgba(0,0,0,0.16);\n  min-width: 280px;\n  max-width: 88vw;\n  text-align: center;\n  overflow: hidden;\n  animation: wlModalIn 0.22s var(--ease);\n}\n@keyframes wlModalIn {\n  from { opacity: 0; transform: scale(0.94) translateY(14px); }\n  to   { opacity: 1; transform: scale(1) translateY(0); }\n}\n.wl-modal::before { content: ''; display: block; height: 3px; background: linear-gradient(90deg, var(--danger), #FF8A80); }\n.wl-modal-icon { font-size: 32px; padding-top: 18px; line-height: 1; }\n.wl-modal h3 { font-family: var(--font); font-size: 15px; font-weight: 800; color: var(--text-1); padding: 8px 22px 3px; margin: 0; }\n.wl-modal p  { font-family: var(--font); font-size: 12.5px; color: var(--text-3); padding: 0 22px 14px; margin: 0; line-height: 1.5; }\n.wl-modal-btns { display: flex; gap: 8px; justify-content: center; padding: 2px 18px 18px; }\n.wl-modal-confirm {\n  padding: 8px 20px;\n  background: var(--danger); color: #fff; border: none; border-radius: 100px;\n  font-family: var(--font); font-size: 12.5px; font-weight: 700; cursor: pointer; transition: all 0.16s;\n}\n.wl-modal-confirm:hover { background: #DC2626; }\n.wl-modal-cancel {\n  padding: 8px 20px;\n  background: #f4f4f4; color: var(--text-2); border: 1px solid var(--border); border-radius: 100px;\n  font-family: var(--font); font-size: 12.5px; font-weight: 600; cursor: pointer; transition: all 0.16s;\n}\n.wl-modal-cancel:hover { background: #eee; }\n\n/* ── Toast ── */\n.wl-toast {\n  position: fixed;\n  bottom: 22px;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 9000;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 16px;\n  border-radius: 100px;\n  font-family: var(--font);\n  font-size: 12.5px;\n  font-weight: 600;\n  box-shadow: 0 5px 20px rgba(0,0,0,0.18);\n  white-space: nowrap;\n  animation: wlToastIn 0.22s var(--ease);\n}\n@keyframes wlToastIn {\n  from { opacity: 0; transform: translateX(-50%) translateY(10px); }\n  to   { opacity: 1; transform: translateX(-50%) translateY(0); }\n}\n.wl-toast--success { background: #111; color: #fff; }\n.wl-toast--error   { background: var(--danger); color: #fff; }\n.wl-toast-cart-btn {\n  padding: 4px 12px;\n  background: var(--orange); color: #fff; border: none; border-radius: 100px;\n  font-family: var(--font); font-size: 11.5px; font-weight: 700; cursor: pointer;\n}\n.wl-toast-cart-btn:hover { background: var(--orange-deep); }\n\n/* ======================================\n   RESPONSIVE\n====================================== */\n/* 4 cols on medium desktop */\n@media (max-width: 1100px) {\n  .wl-grid { grid-template-columns: repeat(4, 1fr); }\n}\n\n/* 3 cols on tablet */\n@media (max-width: 820px) {\n  .wl-grid { grid-template-columns: repeat(3, 1fr); gap: 12px; }\n  .wl-content { padding: 16px 14px 50px; }\n}\n\n/* 2 cols on mobile — SMALL images */\n@media (max-width: 600px) {\n  .wl-page {width: 100%;  border-radius: 0; padding: 16px 12px 30px;}\n  .wl-grid { grid-template-columns: repeat(2, 1fr); gap: 9px; }\n  .wl-content { padding: 12px 10px 50px; gap: 20px;}\n\n  /* KEY FIX: much shorter image on mobile */\n  .wl-card-img-wrap { height: 110px; }\n\n  .wl-card-body  { padding: 8px 10px 10px; gap: 1px; }\n  .wl-card-name  { font-size: 11.5px; }\n  .wl-card-price { font-size: 13.5px; }\n  .wl-card-discount-text { font-size: 10.5px; }\n  .wl-card-mrp   { font-size: 10px; }\n  .wl-card-cart-btn   { font-size: 11px; padding: 7px 0; margin-top: 7px; }\n  .wl-card-remove-btn { font-size: 10px; padding: 5px 0; }\n  .wl-card-divider    { margin: 5px 0 4px; }\n\n  .wl-topbar       { padding: 9px 12px; gap: 10px; }\n  .wl-topbar-title { font-size: 13.5px; }\n  .wl-back-btn     { padding: 5px 11px; font-size: 11.5px; }\n\n  .wl-toast {\n    border-radius: 10px; white-space: normal; flex-direction: column;\n    gap: 5px; max-width: 86vw; text-align: center; bottom: 12px;\n  }\n}\n\n/* Very small phones */\n@media (max-width: 380px) {\n  .wl-card-img-wrap { height: 95px; }\n  .wl-card-name     { font-size: 11px; }\n  .wl-card-price    { font-size: 13px; }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
